@if (!isLoading) {
  @if (displayManageSections()) {
    <im-item-sections
      [toggleSectionsForForm]="toggleSectionsForForm"
      [accordeonExpanded]="sectionsExpanded"
      (toggleChanged)="onToggleChanged($event.formId, $event.sectionId)"
      (itemSectionsDestroyed)="onItemSectionsDestroyed()"
    >
    </im-item-sections>
  }
  <im-items-container
    [items]="items"
    [inspectionId]="inspectionId"
    [itemId]="itemId"
    [config]="config"
    (selectedItemChanged)="onSelectedItemChanged($event)"
    (editedItem)="onEditedItem($event)"
    (deletedItem)="onDeletedItem($event)"
  >
  </im-items-container>
  @if (config?.allowAddProduct && showSpeedDial) {
    <im-item-button
      [defaultFormId]="defaultFormId"
      [allowToDisableSections]="allowToDisableSections"
      [items]="items"
      [showSectionsDialog]="!creationMode()"
      [inspectionId]="inspectionId"
      (itemsSelected)="onItemsCreated($event)"
    >
    </im-item-button>
  }
}

@if (isLoading) {
  <mat-spinner diameter="32"></mat-spinner>
}
